// A popup portalled to <body> sits at the end of the tab order. Tab out of it
// should continue from the control that opened it, not from the end of the
// document: focus the control after (or, with Shift, before) the trigger.
export function focusBeside(trigger: HTMLElement | null, backwards: boolean) {
  if (!trigger) return;
  const controls = Array.from(
    document.querySelectorAll<HTMLElement>("a[href], button, input, select, textarea, [tabindex]"),
  ).filter(
    (element) =>
      element === trigger ||
      (element.tabIndex >= 0 &&
        !element.matches(":disabled") &&
        !element.closest('[hidden], [inert], [aria-hidden="true"]') &&
        getComputedStyle(element).display !== "none" &&
        getComputedStyle(element).visibility !== "hidden"),
  );
  const index = controls.indexOf(trigger);
  (controls[index + (backwards ? -1 : 1)] ?? trigger).focus();
}
